import { LitElement, html, TemplateResult } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { GzIconWebComponent } from '../../gzIcon';
import { uiIconSet } from '../uiIconSet';
import { ButtonColor } from '../../gzIconButton/types';

@customElement('gz-price-discount')
export class GzPriceDiscountWebComponent extends LitElement {
  //value with 3 chars long
  @property({ type: Number, attribute: true, reflect: true })
  discountPercent = 30;

  private text: string = 'OFF';
  static get styles() {
    return styles;
  }

  render(): TemplateResult {
    return html`
      ${this.renderIcon('ds-icon-discount')}
      <div class="discount-tag d-flex flex-row">
        <p class="percent">${this.discountPercent + '%'}</p>
        <p class="text">${this.text}</p>
      </div>
    `;
  }

  private renderIcon(iconName: string): TemplateResult {
    const gzIcon = new GzIconWebComponent();
    gzIcon.setCustomIconSet(uiIconSet);
    gzIcon.name = iconName;
    gzIcon.color = ButtonColor.NEGATIVE;
    gzIcon.size = 73;
    return html`${gzIcon}`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-price-discount': GzPriceDiscountWebComponent;
  }
}
